
















import {
	computed,
	defineComponent,
	PropType,
	Ref,
} from '@vue/composition-api';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';
import { OrganizationType } from '@front-app/services/OrganizationsApi/OrganizationModel';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';

const OPTION_LABELS = [
	OrganizationType.ALLIED_HEALTH,
	OrganizationType.BIOTECHNOLOGY,
	OrganizationType.DENTAL,
	OrganizationType.DIAGNOSTIC_SERVICE_PROVIDER,
	OrganizationType.EDUCATIONAL_INSTITUTE,
	OrganizationType.FAMILY_MEDICINE,
	OrganizationType.GOVERNMENT,
	OrganizationType.HEALTH_SCIENCES,
	OrganizationType.HOME_HEALTH_CARE,
	OrganizationType.HOSPITAL,
	OrganizationType.INSURANCE,
	OrganizationType.LONG_TERM_CARE,
	OrganizationType.MEDICAL_EQUIPMENT,
	OrganizationType.MEDICAL_LABORATORY,
	OrganizationType.MEDICAL_LEGAL_CLAIM,
	OrganizationType.MEDICAL_PUBLISHERS,
	OrganizationType.MENTAL_HEALTHCARE,
	OrganizationType.NOT_FOR_PROFIT_FOUNDATIONS_AND_ASSOCIATIONS,
	OrganizationType.PHARMACEUTICAL,
	OrganizationType.PHARMACY,
	OrganizationType.REHABILITATION,
	OrganizationType.SELF_EMPLOYMENT,
	OrganizationType.SPECIALTY_MEDICINE,
	OrganizationType.THERAPY_WELLNESS_CLINIC,
	OrganizationType.WALK_IN_CARE,
	OrganizationType.OTHER,
];

const DEFAULT_ORGANIZATION = OrganizationType.ALLIED_HEALTH;

export default defineComponent({
	components: { SelectBox },
	props: {
		value: {
			type: String as PropType<OrganizationType | undefined>,
			default: DEFAULT_ORGANIZATION,
		},
	},
	setup(props, ctx) {
		// eslint-disable-next-line arrow-body-style
		const computedValue = computed(() => ((props.value && OPTION_LABELS.includes(props.value))
			? props.value
			: DEFAULT_ORGANIZATION));
		const organizationTypes: Ref<SelectBoxChoice[]> = computed(() => OPTION_LABELS.map((key) => ({
			key,
			label: ctx.root.$t(key) as string,
		})));
		return {
			computedValue,
			organizationTypes,
		};
	},
});
